import can from 'can';
import {BaseMap} from '../../js/usga.base-map';
import {LeaderBoardBaseMap} from '../leaderboard-base/leaderboard-base-map';

export const LeaderBoardPlayersRounds = LeaderBoardBaseMap.extend({
    define: {
        round: {
            Type: BaseMap.List,
            Value: BaseMap.List
        }
    }
});

export const LeaderBoardPlayer = LeaderBoardBaseMap.extend({
    define: {
        name: {
            type: 'string',
            value: ''
        },
        firstname: {
            type: 'string',
            value: ''
        },
        lastname: {
            type: 'string',
            value: ''
        },
        rounds: {
            Type: LeaderBoardPlayersRounds,
            Value: LeaderBoardPlayersRounds
        },
        round: {
            Type: BaseMap.List,
            Value: BaseMap.List
        },
        roundData: {
            type: '*',
            value: null
        }
    },
    isAmateur: can.compute(function() {
		const name = this.attr('name');
		const amateurRegExp = /\(a\)$/ig;
		return amateurRegExp.test(name);
    }),
    isInternational: can.compute(function() {
		const country = this.attr('country');
		if (country !== 'USA') {
            return true;
        }
    }),
    displayName: can.compute(function() {
		let name = this.attr('name');
		const amateurRegExp = /\(a\)$/ig;
		if (name !== '') {
            name = name.split(',');
			let firstName = name[1] ? name[1].trim() : '';
			let lastName = name[0] ? name[0].trim() : '';
			if (amateurRegExp.test(name)) {
                firstName = firstName.replace(amateurRegExp, '');
                lastName = lastName.replace(amateurRegExp, '');
                return firstName + ' ' + lastName + ' (a)';
            } else {
                return firstName + ' ' + lastName;
            }
        }
        return null;
    }),
    shortName: can.compute(function() {
		const name = this.attr('name');
		const displayName = this.attr('displayName');
		const firstName = this.attr('firstname');
		const lastName = this.attr('lastname');
		let shortName = '';

		let amateur = displayName.includes('(a)') ? '(a)' : '';
		let strArr = amateur ?  displayName.replace('(a)', '').split(' ') : displayName.split(' ');
        for (let i = 0; i < strArr.length; i++) {
            if (strArr[i] === '') {
                strArr.splice(i, 1);
                i--;
            }
        }
        const arrLength = strArr.length;
		if (/[A-z-\.\s]*\/[A-z-\.\s]*/.test(name)) {
            shortName = name.replace(/([A-Z]{1})[a-z]*(\s[A-z\.]*)(\s?\/\s?)([A-Z]{1})[a-z]*(\s[A-z\.]*)/, '$1.$2$3$4.$5');
        } else {
			if (firstName !== '' && lastName !== '') {
				shortName = firstName.charAt(0) + '. ' + lastName;
			} else if (firstName !== '' && lastName === '') {
				shortName = firstName;
			} else if (firstName === '' && lastName !== '') {
				shortName = lastName;
			} else if (displayName !== ''){
                //shortName = displayName.replace(/([A-Z]{1})[a-z]*(\s[A-z\.]*)/, '$1.$2');
                shortName = strArr.map((el, index)=> {
                    return index+1 === arrLength ? (el + ' ' + amateur) :
                        el.includes('-') ? el.replace(/([A-Z]{1})[a-z]*(\-)([A-Z]{1})[a-z]*/, '$1.$3.') : el.charAt(0)+'.' ;
                }).join(' ');

            }
        }
        return shortName;
    }),
	lastName: can.compute(function() {
		const name = this.attr('name');
		let lastname = name.split(',')[0];
		return lastname;
	}),
	smallShortName: can.compute(function() {
		return this.attr('shortName').replace(/(\w)/, '<span class="short-name">$1</span>');
	}),
    splitTeamNames: can.compute(function() {
		let name = this.attr('name');
		const country = this.attr('countryname') ? this.attr('countryname') : this.attr('country');
		let firstPlayer, secondPlayer;
		if (name !== '') {
            name = name.split('/');
            firstPlayer = name[0];
            secondPlayer = name[1];
            return [{
                name: firstPlayer,
                country: country
            }, {
                name: secondPlayer,
                country: country
            }];
        }
        return null;
    }),
    getCountry: can.compute(function() {
		const state = this.attr('state');
		const country = this.attr('country');
		const countryName = this.attr('countryname');
		if (state) {
            return state;
        } else if (countryName) {
            return countryName;
        } else {
            return country;
        }
    }),
    idField: can.compute(function() {
        if (this.attr('idint')) {
            return 'player' + this.attr('idint');
        } else {
            return this.attr('name').replace(/\s/ig, '').replace(/\./ig, ''). replace(/,/, '');
        }
    }),
    getRounds: can.compute(function() {
		let rounds;
		if (this.rounds.round.attr('length')) {
            rounds = this.rounds.attr('round');
        } else {
            rounds = this.attr('round');
        }
        return rounds;
    }),
    getHomeTown: can.compute(function() {
        if (this.attr('hometown')) {
            return this.attr('hometown');
        }
        return null;
    }),
    fullName: can.compute(function() {
        return this.attr('firstname') + ' ' + this.attr('lastname');
    }),
    residence: can.compute(function() {
		const homeTown = this.attr('hometown') || '';

		return homeTown;
    }),
    teamName: can.compute(function() {
		let name = this.attr('name');
		name = name.replace(/([A-z\.-]*),\s*([A-z\.-]*)\s*(\/)\s*([A-z\.-]*),\s*([A-z\.-]*)/, '$2 $1 $3 $5 $4');
        return name;
    }),
    shortTeamName: can.compute(function() {
		let name = this.attr('name');
		name = name.replace(/([A-z\.-]*),\s*([A-Z]{1})[A-z\.-]*\s*(\/)\s*([A-z\.-]*),\s*([A-Z]{1})[A-z\.-]*/, '$2. $1 $3<br/>$5. $4');
        return name;
    }),
    photoUrl: can.compute(function() {
		const photoUrl = this.attr('photo');
		if (photoUrl) {
			return photoUrl.replace(/jpe?g$/, 'png');
		} else {
			return null;
		}
    })
});

// USGA defines 'player' as array of objects within an object with key 'players'
export const LeaderBoardPlayers = LeaderBoardBaseMap.extend({
    define: {
        player: {
            Type: LeaderBoardPlayer.List,
            Value: LeaderBoardPlayer.List
        }
    }
});

export const LeaderBoardTeam = LeaderBoardBaseMap.extend({
    define: {
        state: {
            type: 'string',
            value: ''
        },
        players: {
            Type: LeaderBoardPlayers,
            Value: LeaderBoardPlayers
        },
        player: {
            Type: LeaderBoardPlayer,
            Value: LeaderBoardPlayer
        },
        roundData: {
            type: '*',
            value: null
        }
    },
    idField: can.compute(function() {
        if (this.attr('idint')) {
            return 'team' + this.attr('idint');
        } else {
            return this.attr('state').replace(/\s/ig, '');
        }
    })
});
